import axios from "axios";

export const obtenerEstadoPago = async ({idPago}) => {

    let pago = {
        idPago: idPago,
    }

    let data = JSON.stringify(pago);

    let config = {
        method: 'post',
        maxBodyLength: Infinity,
        // url: 'https://ingenieria-n8n.iotr9n.easypanel.host/webhook-test/6be08a6e-2998-4a4c-8f28-3ffe42aaf596', //test
        url: 'https://ingenieria-n8n.iotr9n.easypanel.host/webhook/6be08a6e-2998-4a4c-8f28-3ffe42aaf596',
        headers: {
            'Content-Type': 'application/json'
        },
        data: data
    };

    return axios.request(config)
        .then((response) => {

           // console.log(response);
            if (response.data && response.data[0]) {

                let pago = response.data[0]

                let obj = {
                    id: pago.id,
                    estado: pago.status,
                    detalle: pago.status_detail,
                    fecha: new Date(pago.date_created).getTime(),
                    pagado: pago.transaction_amount
                }

                return obj
            }


        })
        .catch((error) => {
            let obj = {
                id: pago.id,
                exitoso: false,
                estado: 'Error en pago',
                detalle: 'Porfavor comunicate con nosotros',
                fecha: new Date(pago.date_created).getTime(),
                pagado: 0
            }

            return obj
        });


}